module.exports = __webpack_public_path__ + "img/Event.0b32d30a.svg";